import Text from '@/elements/Text'
import Flex from '@/elements/Flex'
import Tabs from '@/components/Tabs'
import settingsTabs from '@/router/tabsSystems/settingsTabs'

function Settings() {
  return (
    <Flex component='section' gap={4} grow>
      <Text variant='h1'>Settings</Text>
      <Tabs tabs={settingsTabs} />
    </Flex>
  )
}

export default Settings
